// This file is generated by the /scripts/updateClientAppWithRepoVersion.js
export const appVersion: string = '0.0.696';
export const appCodeName: string = 'DimSum';
export const builtAt: string = 'Tue Dec 10 2024 10:48:38 GMT+0100 (Central European Standard Time)';
